
const digest = '33e5e640139a8b172cffcd8f4fd68c46a87708c5ff5f6c42f0e16f93f2aa07a3';
const classes = {"wrapper":"_wrapper_1yd4g_1","header":"_header_1yd4g_8","controls1":"_controls-1_1yd4g_18","content":"_content_1yd4g_21","title":"_title_1yd4g_24","from":"_from_1yd4g_29","date":"_date_1yd4g_34","controls2":"_controls-2_1yd4g_40","actual":"_actual_1yd4g_46","formWrapper":"_formWrapper_1yd4g_55","respondButtons":"_respondButtons_1yd4g_58","btn":"_btn_1yd4g_63","attachments":"_attachments_1yd4g_66","responseCancel":"_response-cancel_1yd4g_1"};
const css = `._wrapper_1yd4g_1 {
  font-family: Rubik, sans-serif;
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #ffffff;
}
._wrapper_1yd4g_1 ._header_1yd4g_8 {
  display: flex;
  padding: 20px 24px;
  flex-direction: row;
  background-color: #ffffff;
  align-items: center;
  border: 1px solid #eaedf3;
  z-index: 2;
  box-shadow: 0 4px 0 0 rgba(0, 0, 0, 0.01);
}
._wrapper_1yd4g_1 ._header_1yd4g_8 ._controls-1_1yd4g_18 {
  padding-right: 20px;
}
._wrapper_1yd4g_1 ._header_1yd4g_8 ._content_1yd4g_21 {
  flex-grow: 1;
}
._wrapper_1yd4g_1 ._header_1yd4g_8 ._content_1yd4g_21 ._title_1yd4g_24 {
  font-weight: 500;
  font-size: 14px;
  color: #000000;
}
._wrapper_1yd4g_1 ._header_1yd4g_8 ._content_1yd4g_21 ._from_1yd4g_29 {
  font-weight: 400;
  font-size: 14px;
  color: #000000;
}
._wrapper_1yd4g_1 ._header_1yd4g_8 ._date_1yd4g_34 {
  font-weight: 400;
  font-size: 12px;
  color: #3e3f42;
  padding: 0 20px;
}
._wrapper_1yd4g_1 ._header_1yd4g_8 ._controls-2_1yd4g_40 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding-left: 20px;
}
._wrapper_1yd4g_1 ._actual_1yd4g_46 {
  background-color: #ffffff;
  border: 1px solid #eaedf3;
  border-top: 0;
  padding: 24px;
  font-weight: 400;
  font-size: 16px;
  color: #3e3f42;
}
._wrapper_1yd4g_1 ._actual_1yd4g_46 ._formWrapper_1yd4g_55 {
  margin-top: 30px;
}
._wrapper_1yd4g_1 ._actual_1yd4g_46 ._formWrapper_1yd4g_55 ._respondButtons_1yd4g_58 {
  display: flex;
  flex-direction: row;
  gap: 10px;
}
._wrapper_1yd4g_1 ._actual_1yd4g_46 ._btn_1yd4g_63 {
  width: fit-content;
}
._wrapper_1yd4g_1 ._actual_1yd4g_46 ._attachments_1yd4g_66 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-top: 10px;
  flex-wrap: wrap;
}
._wrapper_1yd4g_1 ._actual_1yd4g_46 ._attachments_1yd4g_66 ._title_1yd4g_24 {
  font-weight: 500;
  font-size: 14px;
  color: #1665d8;
}

#_response-cancel_1yd4g_1 {
  cursor: pointer;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  